export default function AboutIntro() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <span className="inline-block text-xs font-medium text-secondary-600 uppercase tracking-wider mb-3">
              The Ultimate Shopping Research Tool
            </span>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-2">
              Discover Better
            </h2>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-2">
              Products Faster
            </h2>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-primary-500 leading-tight mb-6">
              With Kakobuy
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md mb-6">
              Stop wasting hours searching for products. Our Kakobuy Spreadsheet guides organize trending products, categories, prices, and shopping insights in one convenient place. Whether you are hunting for sneakers, fashion, electronics, or accessories — our spreadsheet database makes product research effortless.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                Buy It Now
                <i className="ri-shopping-cart-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-7 py-3 border border-primary-300 text-primary-600 hover:bg-primary-50 text-sm font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                Kakobuy Sheet
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
          <div className="flex-1">
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <div className="w-full aspect-[16/9] rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Organized%20modern%20workspace%20with%20dual%20monitors%20displaying%20colorful%20data%20dashboards%2C%20mechanical%20keyboard%2C%20minimalist%20desk%20lamp%2C%20potted%20monstera%20plant%2C%20warm%20afternoon%20light%20through%20blinds%2C%20productive%20tech%20startup%20atmosphere%2C%20clean%20contemporary%20aesthetic&width=800&height=450&seq=about-main-img-v3&orientation=landscape"
                    alt="Organized product research with Kakobuy Spreadsheet database interface"
                    title="Kakobuy Spreadsheet product organization"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="aspect-square rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20typing%20on%20laptop%20keyboard%20with%20warm%20golden%20sunlight%20casting%20dramatic%20shadows%2C%20coffee%20cup%20nearby%2C%20focused%20productive%20morning%20atmosphere%2C%20warm%20amber%20tones%2C%20editorial%20lifestyle%20photography%2C%20cozy%20concentration%20mood&width=400&height=400&seq=about-thumb-01-v3&orientation=squarish"
                    alt="Productive shopping research on Kakobuy Spreadsheet"
                    title="Kakobuy Spreadsheet research in action"
                    className="w-full h-full object-cover"
                  />
              </div>
              <div className="aspect-square rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20organized%20desk%20with%20color%20coded%20sticky%20notes%20notebook%20and%20tablet%2C%20creative%20planning%20session%2C%20soft%20diffused%20overhead%20lighting%2C%20neat%20productive%20aesthetic%2C%20pastel%20stationery%20tones%2C%20intentional%20workspace%20composition&width=400&height=400&seq=about-thumb-02-v3&orientation=squarish"
                    alt="Lifestyle planning with Kakobuy Spreadsheet tools"
                    title="Kakobuy Spreadsheet planning"
                    className="w-full h-full object-cover"
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}